import { PasswordPolicy } from 'src/app/shared/models/AppConfiguration';
import { createReducer, on } from '@ngrx/store';
import * as PasswordPolicyActions from '../actions/password-policy.actions';

export interface PasswordPolicyState {
  passwordPolicy: PasswordPolicy;
}

export const initialState: PasswordPolicyState = {
  passwordPolicy: undefined,
};

export const reducer = createReducer(
  initialState,
  on(PasswordPolicyActions.setPasswordPolicy, (state, action) => ({
    ...state,
    passwordPolicy: action.passwordPolicy,
  })),
);
